<template>
  <div class="datepicker" v-loading="loadingCa" element-loading-text="加载中">
    <div class="datepicker-popup" :style="paneStyle" @mouseover="handleMouseOver" @mouseout="handleMouseOver" v-show="displayDayView">
      <div class="datepicker-ctrl">
        <span class="datepicker-preBtn arrows_l01 arrows" aria-hidden="true" @click="preNextMonthClick(0)"></span>
        <span class="datepicker-nextBtn arrows_r01 arrows" aria-hidden="true" @click="preNextMonthClick(1)"></span>
        <span class="datepicker-preYr arrows_l02 arrows" aria-hidden="true" @click="preNextYearClick(0)"></span>
        <span class="datepicker-nextYr arrows_r02 arrows" aria-hidden="true" @click="preNextYearClick(1)"></span>
      </div>

      <template>
        <div class="datepicker-inner">
          <div class="datepicker-body">
            <p class="datepicker-month">{{stringifyDayHeader(currDate)}}</p>
            <div class="datepicker-weekRange">
              <span v-for="w in text.daysOfWeek">{{w}}</span>
            </div>
            <div class="datepicker-dateRange">
              <template v-for="i in weekTmp">
                <p>
                  <span style="position:relative;" v-for="(d,index) in dateRange.slice(i*7,i*7+7)" class="day-cell" :class="getItemClasses(d)" :data-date="stringify(d.date)" @click="daySelect(d, d.date, $event)">
                    <i style="height:100%;width:100%;font-size:16px;" :class="{active: d.sclass.indexOf('datepicker-item-gray') < 0 && stringify(d.date) == currentIndex}">         
                        <template v-if="d.sclass !== 'datepicker-item-gray'">
                          {{d.text}}
                        </template>
                        <template v-else>
                            {{d.text}}
                        </template>        
                    </i>
                    <em >
                          {{d.recInfo}}
                    </em>
                  </span>
                </p>
              </template>
              
            </div>
			
			<div class="datepicker-btn">
             <button type="button" class="btn btn-primary" @click="ensure">确定</button>
             <button type="button" class="btn btn-primary" @click="goToday">当月</button>
              <button type="button" class="btn btn-primary" @click="withdraw">取消</button></div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {comMixin} from 'util/util.js'
import {mapState} from 'vuex'

export default {
  name: 'calendar',
  mixins:[comMixin],
  props: {
    disabledDaysOfWeek: {
      type: Array,
      default () {
        return []
      }
    },
    width: {//日历宽（高是自适应）
      type: String,
      default: '600px'
    },
    lang: {//根据浏览器语言进行翻译
      type: String,
      default: navigator.language
    },
    borderWidth: {//控制日历宽度
      type: Number,
      default: 2
    },
    onDayClick: {//添加点击事件
      type: Function,
      default () {}
    }
  },
  data () {
    return {
      dateFormat: 'yyyy-MM-dd',
      currDate: this.parse(new Date()),
      dateRange: [],
      paneStyle: {
        width: ''
      },
      displayDayView: true,
      rangeStart: false,
      rangeEnd: false,
      currentIndex:'',
      weekTmp: [0,1,2,3,4,5],
      yearMon:'',				//获取切换年月后有里程的日期和里程数需要传递的参数之一
      selectedDay:''    //获取选定日期轨迹信息需要的参数
    }
  },
  watch: {
    currDate (val,val2) {
        this.getDateRange()
    		this.updatePaneStyle()
        const curDateStr = this.stringify(val)
        const yrNum = curDateStr.split('-')[0]
        const mnNum = curDateStr.split('-')[1]
        this.yearMon = yrNum + mnNum;
        const param = {
    		vehicleId:this.curDeviceObj.vehicleId,
    		deviceId:this.curDeviceObj.deviceId,
    		yearMonth:this.yearMon
    	}
      //调用接口，获取切换后的月份所有有轨迹的日期和当日里程
    	this.$store.dispatch('getNewMonthTrace',param);
    },
    'curDeviceObj.deviceId'(val){
    	const curDateStr = this.stringify(this.currDate)
      const yrNum = curDateStr.split('-')[0]
      const mnNum = curDateStr.split('-')[1]
      this.yearMon = yrNum + mnNum;
      const param = {
    		vehicleId:this.curDeviceObj.vehicleId,
    		deviceId:this.curDeviceObj.deviceId,
    		yearMonth:this.yearMon
    	}
      //调用接口，获取切换后的月份所有有轨迹的日期和当日里程
    	this.$store.dispatch('getNewMonthTrace',param);
    },
    hasTrackDate(val){
    	if(val){
    		this.getDateRange()
    		this.$store.dispatch('loadingFinish')
    	}
    }
  },
  computed: {
  	...mapState({
  		curDeviceObj:state => state.vehicle.curDeviceObj, 
			hasTrackDate:state => state.vehicle.hasTrackDate,
			loadingCa:state=>state.vehicle.loadingCa
		}),
    text () {
      return this.translations(this.lang)
    }
  },
  mounted () {
    this.currDate = this.parse(new Date())
    this.updatePaneStyle()
  },
  methods: {
    handleMouseOver (event) {
      let target = event.target
      // this.rangeEnd = false
      if (!this.rangeStart) {
        return true
      }
      if (event.type === 'mouseout') {
        return true
      }
      while (this.$el.contains(target) && !~target.className.indexOf('day-cell')) {
        target = target.parentNode
      }
      if (~target.className.indexOf('day-cell') && !~target.className.indexOf('datepicker-item-gray')) {
        const rangeEnd = target.getAttribute('data-date')
        if (this.rangeStart < this.parse(rangeEnd)) {
          this.rangeEnd = this.parse(rangeEnd)
        }
      }
    },
    getItemClasses (d) {
      const clazz = [];
      clazz.push(d.sclass)
      if (this.rangeStart && this.rangeEnd && d.sclass !== 'datepicker-item-gray') {
        if (d.date > this.rangeStart && d.date < this.rangeEnd) {
          clazz.push('daytoday-range')
        }
        /* eslint-disable eqeqeq */
        if (this.stringify(d.date) == this.stringify(this.rangeStart)) {
          clazz.push('daytoday-start')
        }
        /* eslint-disable eqeqeq */
        if (this.stringify(d.date) == this.stringify(this.rangeEnd)) {
          clazz.push('daytoday-end')
        }
      }
      return clazz.join(' ')
    },
    translations (lang) {
      lang = lang || 'en'
      let text = {
        daysOfWeek: ['日', '一', '二', '三', '四', '五', '六'],
        months: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
        notSelected: 'Nothing Selected',
        required: 'Required',
        search: 'Search'
      }
      return window.VueCalendarLang ? window.VueCalendarLang(lang) : text
    },
    close () {
      this.displayDayView = this.displayMonthView = this.displayYearView = false
    },
    updatePaneStyle () {
      if (!(this.displayMonthView || this.displayYearView)) {
        this.$nextTick(function () {
          let offsetLeft = this.$el.offsetLeft
          let offsetWidth = this.$el.querySelector('.datepicker-inner').offsetWidth
          let popWidth = this.pane * offsetWidth + this.borderWidth // add border
          this.paneStyle.width = popWidth + 'px'
          if (this.hasInput) {
            if (popWidth + offsetLeft > document.documentElement.clientWidth) {
              this.paneStyle.right = '0px'
            }
          } else {
            this.paneStyle.position = 'initial'
          }
          this.$forceUpdate()//迫使Vue实例重新渲染。
        })
      }
    },
    preNextMonthClick (flag) {
      const year = this.currDate.getFullYear()
      const month = this.currDate.getMonth()
      let date = this.currDate.getDate() 
      let param = {}
      if (flag === 0) {//点击查看上一个月
        const preMonth = this.getYearMonth(year, month - 1)
        this.currDate = new Date(preMonth.year, preMonth.month);
      } else {//点击查看下一个月
        const nextMonth = this.getYearMonth(year, month + 1)
        this.currDate = new Date(nextMonth.year, nextMonth.month);
      }
    },
    preNextYearClick (flag) {
      const year = this.currDate.getFullYear()
      const months = this.currDate.getMonth()
      const date = this.currDate.getDate()
      let param = {}
      if (flag === 0) {//点击查看上一年
        this.currDate = new Date(year - 1, months, date)
      } else {//点击查看下一年
        this.currDate = new Date(year + 1, months, date)
      }
    },
    daySelect (d, date, event) {//点击某一天时
      let el = event.target
      if (el.classList[0] === 'datepicker-item-disable') {
        return false
      } else {
          this.onDayClick(date, this.stringify(date));
        //  const dateText = el.firstChild.data; 
        	const dateStr = this.stringify(date)
        	this.currentIndex = dateStr;//控制class是否active  
          if(d.sclass.indexOf('datepicker-item-gray') < 0){
          	this.selectedDay = dateStr; 
          }  
      }
    },
    ensure(){//点确定按钮=>左侧面板同步选定日期
    	if(this.selectedDay === ''){
    		let nowDate = new Date()
    		this.selectedDay = this.stringify(nowDate)
    	}
    	const obj = {
    		day:this.selectedDay,
    		curDId:this.curDeviceObj.deviceId
    	}
    	this.$store.dispatch('setSelectedDay',obj);
    },
    withdraw(){//点取消按钮
    	this.$store.dispatch('hideCalendar')
    },
    goToday(){//点击‘今天’按钮返回当前日期所在页面
      this.currDate = new Date();
    },
    getYearMonth (year, month) {//获取上一年或下一年对应的年份和月份
      if (month > 11) {
        year++
        month = 0
      } else if (month < 0) {
        year--
        month = 11
      }
      return {year: year, month: month}
    },
    siblingsMonth (v, n) {//获取相邻月份的日期
      return new Date(v.getFullYear(), v.getMonth() * 1 + n)
    },
    stringifyDayHeader (date, month = 0) {//获取“月份 年份”
      const d = this.siblingsMonth(date, month)
      return this.text.months[d.getMonth()] + ' ' + d.getFullYear()
    },
    parse (str) {//格式化日期
      let date
      if (str.length === 10 && (this.dateFormat === 'dd-MM-yyyy' || this.dateFormat === 'dd/MM/yyyy')) {
        date = new Date(str.substring(0, 4), str.substring(5, 7) - 1, str.substring(8, 10))
      } else {
        date = new Date(str)
        date.setHours(0, 0, 0)
      }
      return isNaN(date.getFullYear()) ? new Date() : date
    },
    getDateRange () {//**              
      this.dateRange = []
      let currMonth = this.siblingsMonth(this.currDate, 0)//p = 0  
      let time = {
          year: currMonth.getFullYear(),// 年份  2017
          month: currMonth.getMonth()  //月份   2
      } 
        //后台只传一个月的数据
    //    const recInfoList = this.recordInfo.infoList; 
    	const curMonthRec = this.hasTrackDate
        //后台传三个月的数据
    //    const preMonthRec = this.recordInfo[0].infoList
   //     const curMonthRec = this.recordInfo[1].infoList
   //     const nextMonthRec = this.recordInfo[2].infoList
        
        const currMonthFirstDay = new Date(time.year, time.month, 1)//该月第一天
        let firstDayWeek = currMonthFirstDay.getDay() + 1  //该月第一天是周几
        if (firstDayWeek === 0) {
          firstDayWeek = 7
        }
        const dayCount = this.getDayCount(time.year, time.month) //该月总天数
        if (firstDayWeek > 1) { //该月1号前面要显示上个月的几天	
          const preMonth = this.getYearMonth(time.year, time.month - 1) //1 - 2月，2 - 3月
          const prevMonthDayCount = this.getDayCount(preMonth.year, preMonth.month)
          for (let i = 1; i < firstDayWeek; i++) {
            const dayText = prevMonthDayCount - firstDayWeek + i + 1;
            let dateStr = new Date(preMonth.year, preMonth.month, dayText);
            /*let rec = '';
           	for(let j = 0; j < preMonthRec.length;j ++){
           		let	dateS = preMonthRec[j].date;
							let	infoS = preMonthRec[j].info; 	
							if(this.stringify(dateStr) === dateS){				
									rec = infoS;
							}
           	}*/
            this.dateRange.push({
              text: dayText,
              date: dateStr,
              sclass: 'datepicker-item-gray last-month'
            //  recInfo:rec
            })
          }
        } 
        
        let hasInfo = [];//用来存储有行驶记录的索引值
        for (let i = 1; i <= dayCount; i++) {
	        const date = new Date(time.year, time.month, i)
	        const week = date.getDay()
	        let sclass = ''   
	        this.disabledDaysOfWeek.forEach((el) => {
	           if (week === parseInt(el, 10)) sclass = 'datepicker-item-disable'
	        })
          
	        let rec = '';//行驶里程数
			for(var j = 0,length = curMonthRec.length; j < length; j++){	  	
				let	dateS = curMonthRec[j].date.split(' ')[0];
				let	infoS = curMonthRec[j].mileage; 					
				if(this.stringify(date) === dateS){				
					rec = infoS;
					hasInfo.push(i);
				}	
			}
          	const sourceIndex = hasInfo.find(n=>n == i);
		        if(sourceIndex === undefined){//没有行驶记录时的className
		            sclass = 'datepicker-item-gray'
		    }
	        if (i === new Date().getDate()) {
	          	let date = this.stringify(new Date())
	          	const valueDate = this.parse(date)
	            if (valueDate) {
	                if (valueDate.getFullYear() === time.year && valueDate.getMonth() === time.month) {
	                    sclass = 'datepicker-dateRange-item-active'
	                }
	            }
	        }  
          this.dateRange.push({
            text: i,
            date: date,
            sclass: sclass,
            recInfo:rec
          })
        }
        
        if (this.dateRange.length < 42) {
          const nextMonthNeed = 42 - this.dateRange.length
          const nextMonth = this.getYearMonth(time.year, time.month + 1)
          for (let i = 1; i <= nextMonthNeed; i++) {
          	let dateStr = new Date(nextMonth.year, nextMonth.month, i);
          	/*let rec = '';
          	for(var j = 0; j < nextMonthRec.length; j++){
          		let	dateS = nextMonthRec[j].date;
							let	infoS = nextMonthRec[j].info; 	
							if(this.stringify(dateStr) === dateS){				
									rec = infoS;
							}
          	}*/
            this.dateRange.push({
              text: i,
              date: dateStr,
              sclass: 'datepicker-item-gray next-month'
            //  recInfo:rec
            })
          }
        }
    },//getDateRange方法结束
    isDate(v) {
		if(v instanceof Date) {
			return true
		}
		return false
	},
	filled(v) {
		return String(v).replace(/^(\d)$/, '0$1')
	}
  }
}


</script>

<style lang="scss" scoped>
@mixin clearfix() {
  &:before,
  &:after {
    content: " "; // 1
    display: table; // 2
  }
  &:after {
    clear: both;
  }
}
.arrows{
	cursor:pointer
}

</style>



// WEBPACK FOOTER //
// Calendar.vue?e57c4f7a